import { getAuth } from 'firebase/auth';
import axios from 'axios';
import { FIREBASE_FUNCTION_URL } from '../app-settings';
import { CardCollectionFunctionRequest } from '../models/CloudFunction';
import { typesenseClient } from '../typesense';

export async function updateCardCollection(records: Record<string, number>): Promise<void> {
    const auth = getAuth();
    if (!auth.currentUser) {
        return Promise.reject();
    }

    const userToken = await auth.currentUser.getIdToken();

    const requestBody: CardCollectionFunctionRequest<Record<string, number>> = {
        functionName: "savecollection",
        body: records
    };

    await axios.post(`${FIREBASE_FUNCTION_URL}/cardcollection`, requestBody, { headers: { Authorization: `Bearer ${userToken}` } });
}

export async function deleteCardCollection(): Promise<void> {
    const auth = getAuth();
    if (!auth.currentUser) {
        return Promise.reject();
    }

    const userToken = await auth.currentUser.getIdToken();

    const requestBody: CardCollectionFunctionRequest<null> = {
        functionName: "deletecollection",
        body: null
    };

    await axios.post(`${FIREBASE_FUNCTION_URL}/cardcollection`, requestBody, { headers: { Authorization: `Bearer ${userToken}` } });
}

export async function getCardCollection(): Promise<Record<string, number>> {
    try {
        const auth = getAuth();
        if (!auth.currentUser) {
            return Promise.reject();
        }

        const results = await typesenseClient
            .collections<Record<string, number>>("card-collection")
            .documents(auth.currentUser.uid)
            .retrieve();

        // Collection is stored as a flat object containing not only the variantId/quantity mapping,
        // but also other properties such as id. This is to support upsert without updating the entire document.
        // We don't want to return this id though. Just the collection data.
        delete results["id"];
        return results;
    } catch (e) {
        return Promise.reject("Error fetching collection.");
    }
}